import { render, staticRenderFns } from "./Avantages.vue?vue&type=template&id=54791404&scoped=true&"
import script from "./Avantages.vue?vue&type=script&lang=js&"
export * from "./Avantages.vue?vue&type=script&lang=js&"
import style0 from "./Avantages.vue?vue&type=style&index=0&id=54791404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54791404",
  null
  
)

export default component.exports